// Custom components
import AttachmentWithPreview from 'components/AttachmentWithPreview';

// Styled
import {
  AttachmentsWrapper,
  Attachment,
  AnswerContainer,
  DescriptionText,
} from './style';

interface TakePhotoWithDescriptionProps {
  attachments: any;
  description?: Record<string, string> | string;
}

const TakePhotoWithDescription: React.FC<TakePhotoWithDescriptionProps> = ({
  attachments,
  description,
}) => {
  return (
    <AttachmentWithPreview attachments={attachments}>
      {(handleClickAttachment) => (
        <AttachmentsWrapper>
          {attachments.map((att, index) => (
            <AnswerContainer
              key={att}
              direction="row"
              spacing={2}
              justifyContent="space-between"
              width="100%"
            >
              {description?.[att] && (
                <DescriptionText>{description?.[att]}</DescriptionText>
              )}
              <Attachment
                onClick={() => handleClickAttachment(index)}
                src={att}
              />
            </AnswerContainer>
          ))}
        </AttachmentsWrapper>
      )}
    </AttachmentWithPreview>
  );
};

export default TakePhotoWithDescription;
